'use client'

import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

type Props = {
  children: React.ReactNode
}

export const RecaptchaProvider = ({ children }: Props) => {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY!}
    >
      {children}
    </GoogleReCaptchaProvider>
  )
}
